/**
 * プロフィールのフィールド名
 */
export const PROFILE_FIELD_NAME = {
  /**
   * 出願番号
   */
  APPLICATION_NUMBER: 'applicationNumber',
  /**
   * 学籍番号
   */
  STUDENT_NUMBER: 'studentNumber',
  /**
   * 社員番号
   */
  EMPLOYEE_NUMBER: 'employeeNumber',
} as const;

/**
 * 学校法人日本財団ドワンゴ学園 ZEN大学の組織ロール
 * @see https://github.com/dw-zenid/zenid/blob/b8ed77fd405ecaa5e32b27aaac539b42e04e03b1/docs/public/articles/spec/2025-04_organization.md?plain=1#L31C5-L38
 */
export const NFDW_EDU_ZEN_UNIVERSITY = {
  /** 出願者 */
  APPLICANT: 'applicant',
  /** 正科生 */
  STUDENT_REGULAR: 'student/regular',
  /** 科目等履修生 */
  STUDENT_CREDITED_AUDITOR: 'student/credited-auditor',
  /** 特別聴講生 */
  STUDENT_SPECIAL_AUDITOR: 'student/special-auditor',
  /** 聴講生 */
  STUDENT_AUDITOR: 'student/auditor',
  /** 保証人 */
  GUARANTOR: 'guarantor',
} as const;
